((e, t) => {
    "use strict";
    const a = {},
        o = e => {
            let a = !1,
                o = t("[data-trigger=" + e.attr("data-trigger") + "]").not(e);
            o.length > 1 && (a = !0),
            e.siblings("[data-target]").slideToggle("300"),
            e.hasClass("active") ? e.removeClass("active") : (e.addClass("active"), a && (o.removeClass("active"), o.siblings("[data-target]").each(function() {
                t(this).slideUp("300")
            })))
        },
        i = () => {
            a.trigger.on("click", e => {
                t(e.currentTarget).hasClass("js-mobile-accordion") && a.window.innerWidth() < 768 ? o(t(e.currentTarget)) : t(e.currentTarget).hasClass("accordion-header--pdp") && (e => {
                    e.toggleClass("active"),
                    e.siblings().toggleClass("active"),
                    e.siblings().slideToggle()
                })(t(e.currentTarget))
            }),
            a.faqTrigger.on("click", function() {
                t(this).toggleClass("is-active"),
                t(this).next(a.faqTarget).slideToggle()
            })
        };
    e.init = (() => {
        console.log("Accordion is on"),
        a.trigger = t("[data-trigger]"),
        a.target = t("[data-target]"),
        a.window = t(window),
        a.faqTrigger = t(".js-faq-trigger"),
        a.faqTarget = t(".js-faq-target"),
        a.faqTarget.hide(),
        i()
    })
})(bvaccel.Accordion = bvaccel.Accordion || {}, jQuery),
function(e, t) {
    "use strict";
    const a = {},
        o = () => window.location.pathname.split(/\s*\/\s*/).filter(function(e) {
            return "" != e
        }),
        i = () => {
            a.recoverTrigger.on("click", function(e) {
                e.preventDefault(),
                a.newAccount.hide(),
                a.loginForm.hide(),
                a.recoverForm.show()
            }),
            a.addressAddTrigger.on("click", function() {
                var e;
                e = t(this),
                a.address.addClass("is-hidden"),
                a.addressAddTrigger.addClass("is-hidden"),
                a.addressEditForm.removeClass("is-active"),
                a.addressAddForm.addClass("is-active"),
                e.closest(a.addressWrapper).addClass("is-active"),
                e.addClass("is-hidden")
            }),
            a.addressEditTrigger.on("click", function() {
                (e => {
                    let o = e.attr("data-edit-address");
                    a.address.addClass("is-hidden"),
                    a.addressAddTrigger.addClass("is-hidden"),
                    a.addressEditForm.removeClass("is-active"),
                    t('[data-edit-address-form="' + o + '"]').addClass("is-active"),
                    e.closest(a.addressWrapper).addClass("is-active")
                })(t(this))
            }),
            a.addressFormCancel.on("click", function() {
                a.address.removeClass("is-hidden"),
                a.addressAddTrigger.removeClass("is-hidden"),
                a.addressEditForm.removeClass("is-active"),
                a.addressAddForm.removeClass("is-active"),
                a.addressWrapper.removeClass("is-active")
            }),
            a.orderLink.on("click", function() {
                let e = t(this).attr("data-order");
                window.location.href = e
            }),
            a.mobileNav.on("change", function() {
                let e = t(this).find(":selected").attr("data-url");
                window.location.href = e
            })
        };
    e.init = (() => {
        a.loginForm = t("[data-login-form]"),
        a.recoverForm = t("[data-recover-form]"),
        a.recoverTrigger = t("[data-recover-trigger]"),
        a.newAccount = t("[data-new-account]"),
        a.address = t("[data-address]"),
        a.addressAddTrigger = t("[data-add-address]"),
        a.addressEditTrigger = t("[data-edit-address]"),
        a.addressFormCancel = t(".js-address-form-cancel"),
        a.addressAddForm = t("[data-add-address-form]"),
        a.addressEditForm = t("[data-edit-address-form]"),
        a.addressWrapper = t(".js-address-wrapper"),
        a.orderLink = t("[data-order]"),
        a.mobileNav = t("[data-mobile-nav]"),
        i(),
        o().indexOf("addresses") > -1 ? t('[data-link="addresses"]').addClass("is-active") : t('[data-link="orders"]').addClass("is-active"),
        o().indexOf("addresses") > -1 ? t('[data-link="addresses"]').attr("selected", "selected") : t('[data-link="orders"]').attr("selected", "selected")
    })
}(bvaccel.Accounts = bvaccel.Accounts || {}, jQuery),
((e, t) => {
    const a = {};
    let o = 0;
    e.togglePlusIcon = (e => {
        t(e.currentTarget).find(".vertical").toggleClass("close"),
        t(e.currentTarget).find(".horizontal").toggleClass("close")
    });
    const i = e => {
            t(e).each(function(e) {
                let a = t(this).offset().top;
                t(window).scrollTop() + t(window).height() > a + 100 ? (t(this).removeClass("fade--out"), t(this).addClass("fade--in")) : (t(this).removeClass("fade--in"), t(this).addClass("fade--out"))
            })
        },
        s = () => {
            let e = event.clientX;
            e < o ? t(".js-follow-fish").addClass("is-left").removeClass("is-right") : t(".js-follow-fish").removeClass("is-left").addClass("is-right"),
            o = e
        },
        r = () => {
            t(".js-follow-fish").css({
                left: event.clientX,
                top: event.clientY
            })
        };
    e.init = (() => {
        a.toggleCTA = t("[data-multiple-cta]"),
        a.animateIcon = t("[data-animate]"),
        a.toggleCTA.on("click", a => {
            e.togglePlusIcon(a),
            t(a.currentTarget).find(".link-wrapper").toggleClass("active"),
            t(a.currentTarget).find(".multiple-cta__wrapper").toggleClass("active")
        }),
        t(document).on("mousemove", e => {
            r(),
            s()
        }),
        t(window).on("scroll", function() {
            i(".fade-in")
        })
    })
})(bvaccel.Animations = bvaccel.Animations || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {};
    e.init = (() => {
        a.searchItem = t(".search-item"),
        (() => {
            const e = `/blogs/${bvaccel.blogHandle}?view=fetch.articles`;
            fetch(e, {
                credentials: "include"
            }).then(e => e.text()).then(e => {
                t(".blog-grid__wrapper").append(e),
                bvaccel.totalPages != bvaccel.currPage && bvaccel.totalPages > 0 && t(".load-more-btn").addClass("active")
            })
        })(),
        t("main").on("click", ".load-more-btn", e => {
            let a = t("[data-load-more]").last().attr("data-load-more"),
                o = fetch(a, {
                    credentials: "include"
                }).then(e => e.text()),
                i = bvaccel.totalPages,
                s = bvaccel.currPage + 1;
            o.then(e => {
                t(".blog-grid__wrapper").append(e),
                i === s && t(".load-more-btn").hide()
            })
        })
    })
})(bvaccel.Blog = bvaccel.Blog || {}, jQuery),
((e, t) => {
    const a = {};
    let o;
    const i = () => {
            if (!a.CategoryNav.length)
                return !1;
            let e = 0;
            a.CategoryNav.find(".category-nav-slide").each(function() {
                e += t(this).outerWidth()
            }),
            o = Math.ceil(e)
        },
        s = () => {
            i(),
            a.window.on("resize", function() {
                a.window.innerWidth() > o ? a.CategoryNav.addClass("category-nav-slider--full") : a.CategoryNav.removeClass("category-nav-slider--full")
            }),
            a.window.trigger("resize")
        };
    e.init = (() => {
        a.window = t(window),
        a.CategoryNav = t("[data-category-nav-slider]"),
        s()
    })
})(bvaccel.CategoryNav = bvaccel.CategoryNav || {}, jQuery),
((e, t) => {
    const a = {},
        o = e => {
            window.location.search = "?sort_by=" + t(e.currentTarget).attr("data-sort")
        };
    e.init = (() => {
        a.sortByLink = t("[data-sort]"),
        a.sortByLink.on("click", o)
    })
})(bvaccel.Collection = bvaccel.Collection || {}, jQuery),
((e, t) => {
    const a = {};
    let o,
        i = {
            multifilter: {
                enable: !0
            },
            animation: {
                enable: !1
            },
            callbacks: {
                onMixStart: function(e) {},
                onMixEnd: function(e) {}
            }
        };
    const s = e => {
            const a = t(e.currentTarget),
                o = a.attr("data-filter-name"),
                i = a.attr("data-filter-list"),
                s = t("[data-active-filter-list=" + i + "]");
            if (a.hasClass("mixitup-control-active")) {
                const e = s.attr("data-active-filters").split(", ").filter(e => e != o).join(", ");
                s.attr("data-active-filters", e)
            } else if (null == s.attr("data-active-filters") || "" == s.attr("data-active-filters"))
                s.attr("data-active-filters", o);
            else {
                let e = s.attr("data-active-filters");
                if (-1 == e.indexOf(o)) {
                    const t = e + ", " + o;
                    s.attr("data-active-filters", t)
                }
            }
            s.text(s.attr("data-active-filters"))
        },
        r = () => {
            t("[data-active-filters]").each(function() {
                t(this).text(""),
                t(this).attr("data-active-filters", "")
            })
        },
        l = () => {
            r(),
            mixer.parseFilterGroups()
        },
        c = e => {
            d();
            const a = t(e.currentTarget).attr("data-modal-menu-btn");
            t("[data-modal-menu=" + a + "]").addClass("active"),
            bvaccel.Overlay.show(),
            bvaccel.Scroll.lock()
        },
        n = e => {
            a.mobileMenu.removeClass("active"),
            bvaccel.Overlay.hide(),
            bvaccel.Scroll.unlock()
        },
        d = () => {
            let e = 0;
            e = Math.ceil(a.stickyFilterCollection.offset().top),
            a.mobileMenu.css("margin-top", e)
        },
        v = e => {
            window.location.search = "?sort_by=" + t(e.currentTarget).attr("data-sort")
        },
        u = () => {
            (() => {
                const outerHeight = t(".mobile-nav__wrapper_cyan25")[0].offsetTop + t(".mobile-nav__wrapper_cyan25").outerHeight();
                o = a.body.hasClass("collection-filter-mobile-is-stuck") ? outerHeight + t('[data-sticky-filters="header"]').outerHeight() : e
            })(),
            a.window.on("scroll", function() {
                a.window.innerWidth() < 991 && (a.window.scrollTop() > o ? t("body").addClass("collection-filter-mobile-is-stuck") : t("body").removeClass("collection-filter-mobile-is-stuck"))
            }),
            t(window).trigger("scroll")
        };
    e.init = (() => {
        a.body = t("body"),
        a.window = t(window),
        a.header = t(".main-header__wrapper"),
        a.overlay = t("[data-overlay]"),
        a.mixGrid = t("[data-mix-grid]"),
        a.mobileMenu = t("[data-modal-menu]"),
        a.mobileMenuClose = t("[data-modal-menu-close]"),
        a.mobileMenuButton = t("[data-modal-menu-btn]"),
        a.sortByLink = t("[data-sort]"),
        a.stickyFilterHeader = t('[data-sticky-filters="header"]'),
        a.stickyFilterCollection = t('[data-sticky-filters="collection"]'),
        a.filterItem = t(".filter-item[data-toggle]"),
        a.clearFiltersBtn = t("[data-clear-filters]"),
        (() => {
            const e = bvaccel.Helpers.getUrlParameterByName("sort_by");
            e && t('[data-sort="' + e + '"]').addClass("is-active")
        })(),
        console.log("initMixItUp"),
        mixer = mixitup("[data-mix-grid]", i),
        mixer.parseFilterGroups(),
        u(),
        a.sortByLink.on("click", v),
        a.mobileMenuButton.on("click", c),
        a.overlay.on("click", n),
        a.mobileMenuClose.on("click", n),
        a.filterItem.on("click", s),
        a.clearFiltersBtn.on("click", l),
        a.window.on("resize", function() {
            a.window.innerWidth() >= 991 ? n() : d()
        }),
        document.querySelectorAll('[data-filter-list="color"]').forEach(e => {
            const t = e.dataset.filterName.toLowerCase(),
                a = e.querySelector(".filter-color");
            customSwatchColors[t] ? a.style.backgroundColor = customSwatchColors[t] : a.style.backgroundColor = t
        })
    })
})(bvaccel.CollectionFilters = bvaccel.CollectionFilters || {}, jQuery),
((e, t) => {
    const a = {};
    let o;
    const i = () => {
            if (!a.CollectionNav.length)
                return !1;
            let e = 0;
            a.CollectionNav.find(".collection-nav-slide").each(function() {
                e += t(this).outerWidth()
            }),
            o = Math.ceil(e)
        },
        s = () => {
            i(),
            a.window.on("resize", function() {
                a.window.innerWidth() > o ? a.CollectionNav.addClass("collection-nav-slider--full") : a.CollectionNav.removeClass("collection-nav-slider--full")
            }),
            a.window.trigger("resize")
        };
    e.init = (() => {
        a.window = t(window),
        a.CollectionNav = t("[data-collection-nav-slider]"),
        s()
    })
})(bvaccel.CollectionNav = bvaccel.CollectionNav || {}, jQuery),
((e, t) => {
    const a = {};
    let o = Cookies.getJSON("firstVisit") || !1;
    e.init = (() => {
        a.slideUpContainer = t('[data-modal="email-capture"]'),
        !o && a.slideUpContainer.length && (Cookies.set("firstVisit", "true", {
            expires: 30
        }), setTimeout(() => bvaccel.Modals.show("email-capture"), 2500))
    })
})(bvaccel.EmailCapture = bvaccel.EmailCapture || {}, jQuery),
((e, t) => {
    const a = {},
        o = () => {
            a.customSelect.each(function() {
                var e = t(this).attr("class"),
                    a = (t(this).attr("id"), t(this).attr("name"), '<div class="' + e + '">');
                a += '<span class="custom-select-trigger">' + t(this).attr("placeholder") + "</span>",
                a += '<div class="custom-options">',
                t(this).find("option").each(function() {
                    a += '<span class="custom-option ' + t(this).attr("class") + '" data-value="' + t(this).attr("value") + '">' + t(this).html() + "</span>"
                }),
                a += "</div></div>",
                t(this).wrap('<div class="custom-select-wrapper"></div>'),
                t(this).hide(),
                t(this).after(a)
            }),
            t(".custom-option:first-of-type").hover(function() {
                t(this).parents(".custom-options").addClass("option-hover")
            }, function() {
                t(this).parents(".custom-options").removeClass("option-hover")
            }),
            t(".custom-select-trigger").on("click", function() {
                t("html").one("click", function() {
                    a.customSelect.removeClass("opened")
                }),
                t(this).parents(".custom-select").toggleClass("opened"),
                event.stopPropagation()
            }),
            t(".custom-option").on("click", function() {
                t(this).parents(".custom-select-wrapper").find("select").val(t(this).data("value")),
                t(this).parents(".custom-options").find(".custom-option").removeClass("selection"),
                t(this).addClass("selection"),
                t(this).parents(".custom-select").removeClass("opened"),
                t(this).parents(".custom-select").find(".custom-select-trigger").text(t(this).text())
            }),
            a.productRegistrationForm.on("submit", function(e) {
                e.preventDefault();
                let o = {};
                const i = a.productRegistrationForm.children();
                [...i.slice(0, i.length - 1)].map((e, a) => {
                    let i = t(e).attr("name"),
                        s = t(e).val().trim();
                    if ("" !== s)
                        return o[i] = s
                }),
                t.ajax({
                    type: "POST",
                    url: "https://aqualung.bvaccelapps.com/api/registrations",
                    success: function(e) {
                        console.log(e, "formResponse")
                    },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    data: o,
                    dataType: "application/json",
                    error: function(e) {
                        console.error(e, "error")
                    }
                })
            })
        };
    e.init = (() => {
        a.customSelect = t(".custom-select"),
        a.customOption = t(".custom-option"),
        a.customSelectTrigger = t(".custom-select-trigger"),
        a.productRegistrationForm = t(".registration-form"),
        o()
    })
})(bvaccel.Forms = bvaccel.Forms || {}, jQuery),
((e, t) => {
    const a = {};
    e.init = (() => {
        a.gdprBanner = t(".gdpr-banner-container"),
        a.gdprCloseBanner = t(".close-gdpr-banner"),
        a.gdprLargeModal = t(".gdpr-large-modal-container"),
        a.gdprCloseLargeModal = t(".close-gdpr-large-modal"),
        a.gdprSmallModal = t(".gdpr-small-modal-container"),
        a.gdprCloseSmallModal = t(".close-gdpr-small-modal"),
        a.gdprCloseBanner.click(function() {
            a.gdprBanner.hide()
        }),
        a.gdprCloseLargeModal.click(function() {
            a.gdprLargeModal.hide()
        }),
        a.gdprCloseSmallModal.click(function() {
            a.gdprSmallModal.hide()
        })
    })
})(bvaccel.GDPRBannerAndModal = bvaccel.GDPRBannerAndModal || {}, jQuery),
((e, t) => {
    const a = {},
        o = e => {
            e.hasClass("active") ? e.removeClass("active") : e.addClass("active")
        },
        i = () => {
            a.mobileClose.click(e => {
                t('[trigger-menu="main-menu"]').trigger("click"),
                t(e.currentTarget).closest(".active").removeClass("active")
            }),
            t(".mobile-search__inner .search-field").focus(() => o(t(".inner-search-overlay"))),
            t(".mobile-search__inner .search-field").blur(() => o(t(".inner-search-overlay"))),
            t(".mobile-search .search-field").focus(() => o(t(".search-overlay"))),
            t(".mobile-search .search-field").blur(() => o(t(".search-overlay"))),
            t("[data-back]").click(e => t(e.currentTarget).closest(".active").removeClass("active")),
            a.destkopNavTrigger.hover(e => {
                let a = t(e.currentTarget).attr("tier-trigger");
                t(`[tier-target="${a}"]`).addClass("active")
            }, e => {
                let a = t(e.currentTarget).attr("tier-trigger");
                t(`[tier-target="${a}"]`).removeClass("active")
            }),
            t("[search-trigger]").on("click", () => {
                t("[search-target]").hasClass("active") ? (t("[search-target]").removeClass("active"), t("[search-trigger]").removeClass("active")) : (t("[search-trigger]").addClass("active"), t("[search-target]").addClass("active"))
            }),
            a.mobileNavTrigger.on("click", e => {
                let a = t(e.currentTarget).attr("trigger-menu");
                t(`[target-menu=${a}]`).toggleClass("active"),
                "main-menu" == a && (t("[data-push]").hasClass("nav-open") ? t("[data-push]").removeClass("nav-open") : t("[data-push]").addClass("nav-open"))
            }),
            t("[trigger-country]").on("click", () => {
                t("[target-country]").hasClass("active") ? t("[target-country]").removeClass("active") : t("[target-country]").addClass("active")
            }),
            t(".search-field").on("keyup", e => {
                let a = window.innerWidth,
                    o = t(e.currentTarget).val();
                t(".js-search-form").find('input[type="text"]').val(o),
                ((e, a) => {
                    e > 992 ? t(".navigation-search-text").hasClass("desktop-active") && a.length < 1 ? t(".navigation-search-text").removeClass("desktop-active") : (t(".navigation-search-text").addClass("desktop-active"), t(".navigation-search-text").removeClass("mobile-active"), t(".navigation-search-text").text("Enter")) : t(".navigation-search-text").hasClass("mobile-active") && a.length < 1 ? t(".navigation-search-text").removeClass("mobile-active") : (t(".navigation-search-text").addClass("mobile-active"), t(".navigation-search-text").removeClass("desktop-active"), t(".navigation-search-text").text("Clear"))
                })(a, o)
            }),
            t(".navigation-search-text").on("click", e => {
                t(".mobile-active").length > 0 ? t(".search-field").val("") : t(".desktop-active").length > 0 && t(e.currentTarget).closest(".js-search-form").submit()
            }),
            t("[country-flag]").on("click", e => {
                let a = t(e.currentTarget).attr("class");
                t("[country-selected]").attr("class", `country-selected ${a}`),
                t("[target-country]").removeClass("active")
            }),
            t("[search-icon]").on("click", e => {
                if (a.desktopSearch.hasClass("responsive-mode")) {
                    let e = a.desktopSearch.find("input");
                    e.hasClass("active") ? (e.removeClass("active"), t(".placeholder-icon").removeClass("active")) : (e.addClass("active"), t(".placeholder-icon").addClass("active"))
                }
            }),
            t(window).resize(() => {
                let e = window.innerWidth;
                e > 991 && e < 1200 ? (a.desktopSearch.addClass("responsive-mode"), t(".nav-right").addClass("responsive-active")) : (a.desktopSearch.removeClass("responsive-mode"), t(".nav-right").removeClass("responsive-active"))
            }),
            t(window).scroll(() => {
                a.desktopNav.offset().top < 190 && t(".hero__wrapper").length > 0 ? a.desktopNav.removeClass("scrolled") : a.desktopNav.addClass("scrolled")
            })
        };
    e.init = (() => {
        a.desktopNav = t(".desktop-nav__wrapper_cyan25"),
        a.destkopNavTrigger = t("[tier-trigger]"),
        a.destkopNavTarget = t("[tier-target]"),
        a.mobileNavTrigger = t("[trigger-menu]"),
        a.mobileNavTarget = t("[target-menu]"),
        a.mobileClose = t("[data-close]"),
        a.desktopSearch = t("[responsive-search]"),
        (() => {
            let e = window.innerWidth;
            "/" !== window.location.pathname && "/search" !== window.location.pathname || (t("[search-target]").addClass("active"), t("[search-trigger]").addClass("active")),
            e > 991 && e < 1200 ? (a.desktopSearch.addClass("responsive-mode"), t(".nav-right").addClass("responsive-active")) : (a.desktopSearch.removeClass("responsive-mode"), t(".nav-right").removeClass("responsive-active")),
            t(".hero__wrapper").length > 0 ? a.desktopNav.offset().top < 190 ? a.desktopNav.hover(() => a.desktopNav.addClass("hover"), () => a.desktopNav.removeClass("hover")) : (a.desktopNav.addClass("hover"), t("main.content").addClass("padded")) : a.desktopNav.addClass("hover");
            const o = setInterval(() => {
                if (t("[footer-converter] .doubly-nice-select .list [data-country]").length > 0) {
                    clearInterval(o);
                    let e = t("[footer-converter] .doubly-nice-select .list [data-country]"),
                        a = t("[footer-converter] .doubly-nice-select .current");
                    e.map((e, a) => {
                        let o = t(a).data("country"),
                            i = t(a).html().split("&nbsp;");
                        t(a).attr("data-display", o),
                        t(a).html(`${i[0]} ${o}`)
                    }),
                    a.map((a, o) => {
                        t(o).html(t(e[0]).html())
                    })
                }
            }, 400)
        })(),
        i()
    })
})(bvaccel.Header = bvaccel.Header || {}, jQuery),
((e, t) => {
    "use strict";
    e.debounce = ((e, t, a) => {
        let o;
        return function() {
            const i = this,
                s = arguments,
                r = a && !o;
            clearTimeout(o),
            o = setTimeout(function() {
                o = null,
                a || e.apply(i, s)
            }, t),
            r && e.apply(i, s)
        }
    }),
    e.getUrlParameterByName = function(e, t) {
        t || (t = window.location.href),
        e = e.replace(/[\[\]]/g, "\\$&");
        var a = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
        return a ? a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "" : null
    }
})(bvaccel.Helpers = bvaccel.Helpers || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {};
    e.update = (e => {
        t.get("/cart?view=contents", function(e) {
            a.inlineCart.html(e)
        })
    }),
    e.successModal = (e => {
        t.get("/cart?view=success", function(e) {
            a.successEntry.html(e),
            a.successEntry.addClass("active"),
            bvaccel.Overlay.show()
        })
    }),
    e.addItem = ((t, a, o) => {
        CartJS.addItem(t, a, {}, {
            success: function(t, a, o) {
                e.successModal()
            },
            error: function(e) {
                console.log(e)
            }
        })
    }),
    e.updateCartCount = (() => {
        t(document).on("cart.requestComplete", function(e, t) {
            a.cartCount.html(`${t.item_count}`)
        })
    }),
    e.show = (() => {
        a.inlineCart.addClass("is-active")
    }),
    e.hide = (() => {
        a.inlineCart.removeClass("is-active")
    }),
    e.openSuccessModal = (() => {});
    e.init = (() => {
        a.inlineCart = t("[data-inline-cart]"),
        a.lineItemEntryPoint = t("[data-cart-contents]"),
        a.successEntry = t(".js-success-entry"),
        a.cartCount = t("[data-item-counter]"),
        e.updateCartCount()
    })
})(bvaccel.InlineCart = bvaccel.InlineCart || {}, jQuery),
((e, t) => {
    e.init = function() {
        (() => new e)()
    }
})(window.LazyLoad = window.LazyLoad || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {};
    e.openVideoModal = (e => {
        let t = e.attr("data-video-src");
        a.videoIframe.attr("src", t),
        a.videoModal.addClass("active"),
        bvaccel.Overlay.show()
    }),
    e.openSizeModal = (() => {
        a.sizeModal.addClass("active"),
        a.sizeOverlay.fadeIn(300)
    }),
    e.closeVideoModal = (() => {
        bvaccel.Overlay.hide(),
        a.videoIframe.attr("src", ""),
        a.videoModal.removeClass("active")
    }),
    e.closeSizeModal = (() => {
        a.sizeOverlay.fadeOut(300),
        a.sizeModal.removeClass("active")
    }),
    e.hide = (() => {
        a.modal.fadeOut(300),
        bvaccel.Scroll.unlock()
    }),
    e.show = (e => {
        bvaccel.Overlay.show(),
        bvaccel.Scroll.lock(),
        t(`[data-modal="${e}"]`).fadeIn(300)
    });
    const o = () => {
            bvaccel.Overlay.hide()
        },
        i = ({currentTarget: e}) => {
            const a = t(e).attr("data-modal-show");
            bvaccel.Modals.show(a)
        },
        s = () => {
            a.videoModalBtn.on("click", function() {
                e.openVideoModal(t(this))
            }),
            a.closeModalBtn.on("click", function(t) {
                e.closeVideoModal()
            }),
            a.sizeModalBtn.on("click", function() {
                e.openSizeModal()
            }),
            a.closeSizeModal.on("click", function(t) {
                e.closeSizeModal()
            }),
            a.overlay.on("click", function() {
                e.closeVideoModal(),
                e.closeSizeModal()
            }),
            a.modalBtn.on("click", function() {
                const e = t(this).attr("data-modal-btn");
                t('[data-modal="' + e + '"]').addClass("active"),
                bvaccel.Overlay.show(),
                bvaccel.Scroll.lock()
            }),
            t("[data-close-modal]").on("click", function() {
                t(this).closest("[data-modal]").removeClass("active"),
                bvaccel.Overlay.hide(),
                bvaccel.Scroll.unlock()
            }),
            a.modalHide.on("click", o),
            a.modalShow.on("click", i)
        };
    bvaccel.Modals.init = (() => {
        a.closeModalBtn = t(".js-video-modal-close"),
        a.videoModalBtn = t(".js-video-modal-btn"),
        a.videoModal = t(".js-video-modal"),
        a.videoIframe = t(".js-video-modal-iframe"),
        a.sizeModal = t(".js-size-modal"),
        a.closeSizeModal = t(".js-size-modal-close"),
        a.sizeModalBtn = t(".js-size-modal-btn"),
        a.sizeOverlay = t(".js-size-modal-overlay"),
        a.overlay = t("[data-overlay]"),
        a.modalBtn = t("[data-modal-btn]"),
        a.modalHide = t("[data-modal-hide]"),
        a.modalShow = t("[data-modal-show]"),
        a.modal = t("[data-modal]"),
        s()
    })
})(bvaccel.Modals = bvaccel.Modals || {}, jQuery),
((e, t) => {
    "use strict";
    let a = {};
    const o = e => {
            e = e.toLowerCase();
            const t = ['"', "'", "\\", "(", ")", "[", "]", "$"];
            for (let a = 0; a < t.length; ++a)
                e = e.replace(t[a], "");
            return "-" == (e = e.replace(/\W+/g, "-")).charAt(e.length - 1) && (e = e.replace(/-+\z/, "")), "-" == e.charAt(0) && (e = e.replace(/\A-+/, "")), e
        },
        s = (e, a) => {
            t("[data-add-to-cart]", a).attr("data-variant-id", e.id),
            t('[name="contact[variant_id]"]', a).attr("value", e.id),
            t('[name="contact[sku]"]', a).attr("value", e.sku),
            e.available ? (e => {
                t("[data-add-to-cart]", e).hasClass("button_style--atc") || t("[data-add-to-cart]", e).addClass("button_style--atc"),
                t("[data-add-to-cart]", e).removeAttr("disabled").removeClass('si-button SI_trigger').text("Add to Cart")
            })(a) : (e => {
                0 != t("[data-add-to-cart]", e).length && (t("[data-add-to-cart]", e).hasClass("button_style--atc") && t("[data-add-to-cart]", e).removeClass("button_style--atc"), t("[data-add-to-cart]", e).addClass('si-button SI_trigger').text("Out of Stock – Get Notified When Available"))
            })(a);
            var o = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
            window.history.replaceState({
                path: o
            }, "", o)
        },
        r = e => e.filter(function(e) {
            return !1 === e.available
        }),
        l = e => a.variants.filter(function(t) {
            return e.every(function(e, a) {
                return void 0 === e || o(t.options[a]) === e
            })
        }),
        c = e => {
            var o = new Array(a.options.length);
            return t(".product-option__variants [data-variant]:checked", e).each(function(e) {
                var a = t(this).attr("data-option-index"),
                    i = t(this).attr("data-variant");
                o[a] = i
            }), o
        },
        n = (e, a, i) => {
            t("[data-variant]", a).removeClass(i),
            e.forEach(function(e, s) {
                e.forEach(function(e) {
                    const s = o(e);
                    t('[data-variant="' + s + '"]', a).addClass(i)
                })
            })
        },
        d = (e, i, d) => {
            var v = c(e),
                u = l(v)[0];
            if ((e => {
                return t(".product-option__variants [data-variant]:checked", e).length === a.options.length
            })(e) && u) {
                var p = (e => a.variants.filter(function(t) {
                    return e.reduce(function(e, a, i) {
                        if (void 0 !== t.options[i])
                            return o(t.options[i]) === a ? ++e : e
                    }, 0) >= a.options.length - 1
                }))(v);
                s(u, e);
                var m = ((e, t) => {
                    var i = [];
                    return a.options.map(() => {
                        i.push(new Array)
                    }), e.forEach(function(e) {
                        e.options.forEach(function(a, s) {
                            const r = o(a);
                            o(e.option1) == t[0] && i[s].push(r)
                        })
                    }), i.forEach(function(e, t) {
                        i[t] = [...new Set(e)]
                    }), i
                })(r(p), v);
                n(m, e, i),
                ((e, a) => {
                    if (!e)
                        return;
                    const o = (e.price / 100).toFixed(2),
                        i = e.compare_at_price / 100;
                    0 != i ? (t("[data-price]", a).text("$" + o), t("[data-compare-price]", a).text("$" + i.toFixed(2)), t("[data-product-price]", a).addClass("sale")) : (t("[data-price]", a).text("$" + o), t("[data-compare-price]", a).text(""), t("[data-product-price]", a).removeClass("sale"))
                })(u, e)
            } else {
                if ((p = l(v)).length > 0) {
                    m = (e => {
                        var t = [];
                        return e.forEach(function(e) {
                            e.options.forEach(function(e, a) {
                                void 0 === t[a] ? t[a] = [e] : -1 === t[a].indexOf(e) && t[a].push(e)
                            })
                        }), t
                    })(r(p));
                    n(m, e, i)
                } else {
                    s(u, e);
                    let t = v.map(e => [e]);
                    n(t, e, i)
                }
            }
        };
    e.init = function(e) {
        t("[data-variant]").on("click", e => {
            const a = t(e.currentTarget),
                o = a.closest("[data-option-container]");
            d(o, "unavailable")
        }),
        a = e,
        (() => {
            const e = t("[data-option-container]");
            d(e, "unavailable")
        })()
    },
    e.uninit = (() => {
        t("[data-variant]").off()
    })
})(bvaccel.OptionSelection = bvaccel.OptionSelection || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {};
    bvaccel.Overlay.show = function() {
        return a.overlay.fadeIn(300)
    },
    bvaccel.Overlay.hide = (() => (bvaccel.Modals.hide(), a.overlay.fadeOut(300))),
    bvaccel.Overlay.toggle = (() => a.overlay.fadeToggle(300));
    e.init = (() => {
        a.overlay = t("[data-overlay]"),
        a.overlay.on("click", bvaccel.Overlay.hide)
    })
})(bvaccel.Overlay = bvaccel.Overlay || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {},
        o = () => {
            const e = parseInt(t(".slick-list").outerHeight());
            a.zoomBox.css("height", e)
        },
        i = () => {
            a.gallerySlide.bind("mousemove", function(e) {
                const o = t(this);
                a.zoomFollow.css({
                    left: e.clientX - o.offset().left - 100,
                    top: e.clientY - o.offset().top + t(document).scrollTop() - 135
                })
            })
        };
    e.zoom = (() => {
        var e = t("[data-gallery-slide].slick-active");
        ((e, t) => {
            window.outerWidth > 768 && t.zoom({
                url: e,
                touch: !1,
                magnify: 1.5
            })
        })(e.attr("data-zoom-img"), e)
    });
    e.gallery = (() => {
        console.log("Re-build sliders");
        const e = {
            lazyLoad: "progressive",
            mobileFirst: !0,
            arrows: !0,
            dots: !1,
            centerMode: !0,
            infinite: !1,
            variableWidth: !0,
            asNavFor: ".product-gallery__thumbnails",
            centerPadding: "20px",
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [{
                breakpoint: 769,
                settings: {
                    draggable: !1,
                    infinite: !1,
                    centerMode: !1,
                    variableWidth: !1,
                    dots: !1,
                    customPaging: function(e, a) {
                        const o = t(e.$slides[a]).data("thumb");
                        return '<button type="button" name="Product Photo Button" data-filters="' + t(e.$slides[a]).data("filters") + '" data-type="' + t(e.$slides[a]).data("type") + '" data-index="' + a + '"><img src="' + o + '" alt="Product Photo"></button>'
                    }
                }
            }]
        };
        a.productGallery.slick(e),
        a.productGalleryThumbnails.slick({
            lazyLoad: "progressive",
            mobileFirst: !0,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: ".product-gallery__slideshow",
            vertical: !0,
            infinite: !1,
            dots: !1,
            centerMode: !1,
            focusOnSelect: !0,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6
                }
            }]
        });
        const o = t('[data-variant-filter]:not([name="Size"]):checked');
        r(o)
    });
    const s = e => {
            var a = t("[data-product-video]").get(0);
            e ? a.pause() : a.paused ? a.play() : a.pause(),
            t(".product-gallery__slide--video").toggleClass("active")
        },
        r = e => {
            const o = e.closest("[data-option-container]").find('[data-variant-filter]:not([name="Size"]):checked');
            let i = "[data-all],[data-video-slide]";
            o.length > 0 && (i += ","),
            o.each((e, a) => {
                const o = t(a).data("variant-filter");
                i += `[data-filters~="${o}"]`
            }),
            (e => {
                console.log("Filter", e),
                a.productGallery.slick("slickUnfilter"),
                a.productGallery.slick("slickFilter", e),
                a.productGalleryThumbnails.slick("slickUnfilter"),
                a.productGalleryThumbnails.slick("slickFilter", e)
            })(i)
        },
        l = () => {
            t("body").on("click", ".js-modal-close", function() {
                a.successModal.removeClass("active"),
                bvaccel.Overlay.hide()
            }),
            a.scrollToSizeguide.on("click", function() {
                (() => {
                    let e = a.sizeguide.offset().top - a.header.outerHeight();
                    t("html, body").animate({
                        scrollTop: e
                    }, 1e3),
                    a.sizeguideTrigger.trigger("click")
                })()
            }),
            a.productGallery.on("init", function(e, t) {
                o(),
                i()
            }),
            a.productGalleryThumbnails.on("init beforeChange", function() {
                setTimeout(function() {
                    t(".product-gallery__slide-thumbnail").each(function(e) {
                        t(this).attr("data-slick-index", e)
                    })
                }, 100)
            }),
            a.productGallery.on("beforeChange", function(e, a, o, i) {
                const s = t(".product-gallery__slide--video");
                s.hasClass("active") && (t("[data-video-slide] video").get(0).pause(), s.removeClass("active")),
                t(".product-gallery__slide.active-zoom").removeClass("active-zoom")
            }),
            a.productGallery.on("afterChange", function(t, a, o) {
                e.zoom()
            }),
            t(window).on("resize", function() {
                o()
            }),
            a.qtySelect.on("change", function() {
                const e = t(this).val();
                a.addToCart.attr("data-add-qty", e)
            }),
            a.colorVariant.on("click", function() {}),
            a.sizeVariant.on("click", function() {
                a.sizeOptions.removeClass("active"),
                a.mobileSizeBtn.removeClass("active")
            }),
            t("[data-variant-filter]").on("click", function() {
                const e = t(this);
                r(e);
                const a = t(this).val();
                t(this).closest("[data-option-select]").find("[data-option-value]").text(a)
            }),
            a.addToCart.on("click", function() {
                const e = t(this),
                    a = parseInt(e.attr("data-variant-id"));
                bvaccel.InlineCart.addItem(a, 1, t(this))
            }),
            a.gallerySlide.on("click", function() {
                window.outerWidth > 768 && t(this).toggleClass("active-zoom")
            }),
            a.productDescBtn.on("click", function() {
                const e = t(this);
                t("[data-product-description-btn]").removeClass("active"),
                e.addClass("active");
                const a = t("[data-product-" + e.attr("data-product-description-btn") + "]");
                a.hasClass("active") || (t(".product-details.active").removeClass("active"), a.addClass("active"))
            }),
            t('[data-target="product-details-main"]').on("click", function() {
                t('[data-product-description-btn="fit"]').trigger("click")
            }),
            t(document).on("click", '[data-type="video"]', function() {
                s()
            }),
            t("[data-product-video]").bind("webkitendfullscreen", function() {
                s(!0)
            }),
            a.mobileSizeBtn.on("click", function() {
                t(this).toggleClass("active"),
                a.sizeOptions.toggleClass("active")
            })
        };
    e.init = (() => {
        a.productGallery = t("[data-product-gallery]"),
        a.productGalleryThumbnails = t("[data-product-thumbnails]"),
        a.gallerySlide = t("[data-gallery-slide]"),
        a.zoomFollow = t("[data-zoom-follow]"),
        a.zoomBox = t("[data-zoom-box]"),
        a.addToCart = t("[data-add-to-cart]"),
        a.qtySelect = t("[data-qty-input]"),
        a.colorVariant = t("[data-color-variant]"),
        a.sizeVariant = t("[data-size-variant]"),
        a.amountVariant = t("[data-amount-variant]"),
        a.option1 = t("[data-option-1]"),
        a.option2 = t("[data-option-2]"),
        a.productDescBtn = t("[data-product-description-btn]"),
        a.mobileSizeBtn = t("[data-mobile-size-btn]"),
        a.sizeOptions = t("[data-size-options]"),
        a.scrollToSizeguide = t("[data-sizeguide-scroll]"),
        a.sizeguide = t(".accordion-row--sizeguide"),
        a.sizeguideTrigger = t(".accordion-row--sizeguide").find(".accordion-header--pdp"),
        a.header = t(".main-header__wrapper "),
        a.sizeguideContent = t(".js-sizeguide-content"),
        a.successModal = t(".js-success-entry"),
        a.succesModalClose = t(".js-modal-close"),
        a.thumbVideoBtn = t(".js-activate-video-modal"),
        a.thumbnailImg = t(".js-thumb-image"),
        l(),
        e.gallery(),
        e.zoom()
    })
})(bvaccel.Product = bvaccel.Product || {}, jQuery),
((e, t) => {
    "use strict";
    const a = e => {
        const a = t(e.currentTarget),
            o = a.closest(".product-grid-item-inner").find(".product-image-container__image"),
            i = a.attr("data-variant-image-src"),
            s = a.attr("data-variant-image-srcset");
        o.attr("src", i),
        o.attr("srcset", s)
    };
    e.init = (() => {
        t("[data-grid-item-swatch]").on("click, mouseover", a),
        t(".product-item__swatch-list").slick({
            infinite: !1,
            slidesToShow: 3,
            slidesToScroll: 1
        })
    })
})(bvaccel.ProductGridItem = bvaccel.ProductGridItem || {}, jQuery),
((e, t) => {
    const a = {},
        o = () => {
            a.registerProductButton.on("click", function(e) {
                const a = t(this).parent().find(".registration-form--model"),
                    o = t(this).parent().find(".registration-form--serial-num");
                a.get(0).setCustomValidity(""),
                o.get(0).setCustomValidity(""),
                "" === o.val().trim() && "" === a.val().trim() && (a.get(0).setCustomValidity("The model name, serial number, or both fields must be entered"), o.get(0).setCustomValidity("The model name, serial number, or both fields must be entered"))
            })
        };
    e.init = (() => {
        a.registerProductButton = t(".register-product-button"),
        o()
    })
})(bvaccel.ProductRegistration = bvaccel.ProductRegistration || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {},
        o = (e, t) => {
            const a = t.siblings("[data-qty-input]"),
                o = parseInt(a.val());
            e ? a.val(o + 1).change() : 1 !== o && a.val(o - 1).change()
        },
        i = () => {
            a.pdpQtyMinus.on("click", function() {
                o(!1, t(this))
            }),
            a.pdpQtyPlus.on("click", function() {
                o(!0, t(this))
            })
        },
        s = () => {
            t("[data-qty-change]").on("click", function() {
                const e = t(this),
                    a = e.siblings("[data-qty-input]"),
                    o = e.attr("data-cart-qty"),
                    i = e.attr("data-qty-change"),
                    s = e.attr("data-variant-id");
                if (o == i) {
                    const t = e.attr("data-product-title");
                    InlineCart.cartMessage(!0, t, o)
                } else
                    a.val(i),
                    InlineCart.updateLineItem(s, i, 1),
                    InlineCart.cartMessage(!1)
            })
        };
    e.init = (() => {
        a.pdpQtyMinus = t(".pdp[data-qty-minus]"),
        a.pdpQtyPlus = t(".pdp[data-qty-plus]"),
        i(),
        s()
    }),
    e.reinit = (() => {
        s()
    })
})(bvaccel.QuantitySelector = bvaccel.QuantitySelector || {}, jQuery),
((e, t) => {
    const a = {},
        o = () => {
            a.starRating.each((e, a) => {
                ((e, a) => {
                    let o = Math.floor(a),
                        i = a % 1,
                        s = '<span class="start-wrap">',
                        r = '<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><path fill-rule="nonzero" d="M8.379 12.176L13.063 15l-1.24-5.327 4.135-3.583-5.45-.467L8.378.6 6.25 5.623.8 6.09l4.134 3.583L3.695 15z" fill="#a78b4c"/></svg>',
                        l = '<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M15.958 6.09l-5.45-.468L8.378.6 6.25 5.623.8 6.09l4.134 3.582L3.695 15l4.684-2.824L13.063 15l-1.24-5.327 4.135-3.583zm-6.959 5.058l-.62-.374V3.676l1.023 2.415.282.665.72.062 2.621.225-1.988 1.723-.547.474.164.704.596 2.561L9 11.148z" fill-rule="nonzero" fill="#a78b4c"/></svg>',
                        c = '<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M15.958 6.09l-5.45-.468L8.378.6 6.25 5.623.8 6.09l4.134 3.582L3.695 15l4.684-2.824L13.063 15l-1.24-5.327 4.135-3.583zm-6.959 5.058l-.62-.374-.62.374-2.251 1.357.596-2.56.164-.705-.547-.474-1.989-1.723 2.62-.225.721-.062.282-.665L8.38 3.676l1.023 2.415.282.665.72.062 2.621.225-1.988 1.723-.547.474.164.704.596 2.561L9 11.148z" fill-rule="nonzero" fill="#a78b4c"/></svg>';
                    for (let e = 0; e < 4; e++)
                        o <= e ? i < .5 ? s += `<span class="icon icon-empty-star">${c}</span>` : .5 == i ? (s += `<span class="icon icon-star-half">${l}</span>`, i = 0) : i > .5 && (s += `<span class="icon icon-star">${r}</span>`) : s += `<span class="icon icon-star">${r}</span>`;
                    5 === a ? s += `<span class="icon icon-star">${r}</span>` : a > 3.9 ? (i = a % 1) < .25 ? s += `<span class="icon icon-empty-star">${c}</span>` : i > .24 && i < .75 ? s += `<span class="icon icon-star-half">${l}</span>` : i > .74 && (s += `<span class="icon icon-star">${r}</span>`) : s += `<span class="icon icon-empty-star">${c}</span>`,
                    s += "</span>",
                    t(e).html(s)
                })(a, t(a).data("rating"))
            })
        };
    e.init = (() => {
        a.starRating = t("[data-rating]"),
        o()
    })
})(bvaccel.Stars = bvaccel.Stars || {}, jQuery),
((e, t) => {
    "use strict";
    e.lock = (e => {
        t("html, body, body main").addClass("no-scroll")
    }),
    e.unlock = (e => {
        t("html, body, body main").removeClass("no-scroll")
    }),
    e.toggle = (e => {
        t("html, body, body main").toggleClass("no-scroll")
    });
    e.init = (() => {})
})(bvaccel.Scroll = bvaccel.Scroll || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {};
    e.init = (() => {
        a.searchItem = t(".search-item"),
        (e => {
            a.searchItem.map((a, o) => {
                let i = t(o).text();
                console.log(i),
                i.includes(e) && (i = t(o).text().split(e), t(o).find("a").html(`${i[0]}<strong>${e}</strong>${i[1]}`))
            })
        })(bvaccel.searchTerms),
        (e => {
            t(".js-search-form").find('input[type="text"]').val(e)
        })(bvaccel.searchTerms),
        (() => {
            const e = `/search?type=article,page&q=${bvaccel.searchTerms}&view=ajax.pages`,
                a = `/search?type=product&q=${bvaccel.searchTerms}&view=ajax.products`,
                o = {
                    credentials: "include"
                },
                i = fetch(e, o).then(e => e.text());
            fetch(a, o).then(e => e.text()).then(e => {
                t(".display-results__wrapper").append(e),
                bvaccel.totalPages != bvaccel.currPage && bvaccel.totalPages > 0 && t(".load-more-btn").addClass("active")
            }),
            i.then(e => t(".search-results-pages").append(e))
        })(),
        t("main").on("click", ".load-more-btn", e => {
            let a = t("[data-load-more]").last().attr("data-load-more"),
                o = fetch(a, {
                    credentials: "include"
                }).then(e => e.text()),
                i = bvaccel.totalPages,
                s = bvaccel.currPage + 1;
            o.then(e => {
                t(".display-results__wrapper").append(e),
                i === s && t(".load-more-btn").hide()
            })
        })
    })
})(bvaccel.SearchResults = bvaccel.SearchResults || {}, jQuery),
((e, t) => {
    const a = {},
        o = (e=1, t=2, a=1, o=4, i=!0, s=!1, r=!0) => ({
            slidesToScroll: e,
            slidesToShow: t,
            mobileFirst: !0,
            infinite: r,
            arrows: i,
            dots: s,
            prevArrow: '<svg class="arrow-left slick-prev" width="20" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.208c.006.211.07.339.15.43l4.484 5.518c.211.298.691.346.991.103a.679.679 0 0 0 .075-.965L2.134 6.897H19.31a.69.69 0 1 0 0-1.379H2.134L5.7 1.121c.273-.272.196-.75-.092-1.006-.222-.198-.813-.135-.974.144L.15 5.777a.582.582 0 0 0-.151.43z" fill="#000" fill-rule="nonzero"/></svg>',
            nextArrow: '<svg class="arrow-right slick-next" width="20" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M20 6.207c-.005-.212-.07-.34-.15-.431L15.365.258c-.211-.298-.691-.345-.991-.103a.679.679 0 0 0-.075.966l3.566 4.396H.69a.69.69 0 1 0 0 1.38h17.176L14.3 11.292c-.273.272-.196.75.092 1.007.222.197.813.134.974-.145l4.483-5.517A.582.582 0 0 0 20 6.207z" fill="#000" fill-rule="nonzero"/></svg>',
            responsive: [{
                breakpoint: 996,
                settings: {
                    slidesToShow: o,
                    slidesToScroll: a
                }
            }]
        });
    e.init = (() => {
        a.baseSlider = t("[js-top-seller-slider]"),
        a.reviewSlider = t("[js-reviews-slider]"),
        a.brandSlider = t("[js-brand-slider]"),
        a.recommendedProductsSlider = t(".js-related-products-slider"),
        (() => {
            a.baseSlider.slick(o(1, 2, 1, 4, !0, !1)),
            a.reviewSlider.slick(o(1, 1, 1, 3, !0, !1));
            let e = parseInt(a.brandSlider.attr("js-brand-slider")) || 7;
            e > 7 && (e = 7),
            a.brandSlider.slick(o(1, 2, 1, e, !0, !1)),
            a.recommendedProductsSlider.slick(o(1, 2, 1, 4))
        })()
    })
})(bvaccel.Sliders = bvaccel.Sliders || {}, jQuery),
function(e, t) {
    "use strict";
    var a = function() {
        t(document).on("click", "[data-share-icon]", function(e) {
            e.preventDefault(),
            function(e) {
                switch (e) {
                case "facebook":
                    window.open("http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href), "Facebook", "width=600, height=400, scrollbars=no");
                    break;
                case "twitter":
                    window.open("http://www.twitter.com/intent/tweet?url=" + encodeURIComponent(window.location.href), "Tweet", "width=600, height=450, scrollbars=no");
                    break;
                case "pinterest":
                    var a = window.location.href,
                        o = encodeURIComponent(a),
                        i = a.search("/products/");
                    if ("/blogs/news/articles" === window.location.pathname)
                        var s = encodeURIComponent(t("#destination-1 img").attr("src")),
                            r = t(".article-header-content p").text();
                    else
                        -1 != i ? (s = encodeURIComponent(t(".product-slider").find("img").first().attr("src")), r = "TommyJohn " + t(".prod-series").text() + t(".prod-name").text()) : (s = encodeURIComponent(t(".product-photo-thumb.slick-active img").attr("src")), r = t(".product-description").text());
                    window.open("http://pinterest.com/pin/create/link/?url=" + o + "&media=" + s + "&description=" + r, "Pinterest", "width=600, height=600, scrollbars=no");
                    break;
                case "google-plus":
                    window.open("https://plus.google.com/share?url=" + encodeURIComponent(window.location.href), "GooglePlus", "width=680, height=450, scrollbars=no")
                }
            }(t(this).data("network"))
        })
    };
    e.init = (() => {
        a(),
        function() {
            var e = document,
                t = e.getElementsByTagName("SCRIPT")[0],
                a = e.createElement("SCRIPT");
            a.type = "text/javascript",
            a.async = !0,
            a.src = "//assets.pinterest.com/js/pinit.js",
            t.parentNode.insertBefore(a, t)
        }()
    })
}(bvaccel.SocialSharing = bvaccel.SocialSharing || {}, jQuery),
((e, t) => {
    "use strict";
    const a = {},
        o = () => {
            let e = t(window).scrollTop();
            a.timelineProgress.each(function() {
                t(this).offset().top - 200 < e ? t(this).addClass("is-active") : t(this).removeClass("is-active")
            })
        };
    e.init = (() => {
        a.timelineProgress = t(".js-timeline-progress"),
        a.timelineScrollLink = t(".js-timeline-scroll-link"),
        t(window).on("scroll", function() {
            o()
        }),
        a.timelineScrollLink.on("click", function(e) {
            e.preventDefault(),
            t("html, body").animate({
                scrollTop: t("#timeline-list").offset().top - 240
            }, 600)
        })
    })
})(bvaccel.Timeline = bvaccel.Timeline || {}, jQuery);
